import React from "react";
import { Helmet } from "react-helmet-async";

const APP_PATH = "/spectrum-final-app/index.html";

export default function SpectrumStrikeDemoPage() {
  return (
    <div style={{ minHeight: "100vh", background: "#061021" }}>
      <Helmet>
        <title>SALAR Demo | SALAR Technologies LLC</title>
        <meta name="description" content="Explore a public-safe SALAR Technologies LLC interactive demonstration of engineering decision-support and traceable technical analysis." />
        <meta property="og:title" content="SALAR Interactive Demonstration" />
        <meta property="og:description" content="A public-safe SALAR Technologies LLC demonstration of engineering decision-support and traceable technical analysis." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.salartechnologies.com/spectrum-strike-demo" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.salartechnologies.com/spectrum-strike-demo" />
      </Helmet>
      <iframe
        src={APP_PATH}
        title="SALAR Demo"
        allow="clipboard-write"
        style={{ display: "block", width: "100%", minHeight: "1500px", border: 0, background: "#061021" }}
      />
    </div>
  );
}
